export function formatMinutes(unit: string | number | undefined): string {
  const num = Number(unit);
  if (Number.isNaN(num) || num < 0) return '0';
  return num.toString();
}

export function formatSeconds(unit: string | number | undefined): string {
  const num = Number(unit);
  if (Number.isNaN(num) || num < 0) return '00';
  return String(num).padStart(2, '0');
}
